module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /app/node_modules/axios/index.js
// module id = 407
// module chunks = 0